import { isPlatformBrowser } from '@angular/common'
import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core'
import { ApiService } from 'src/app/core/services/api.service'
import { ChatState } from 'src/app/core/services/chat.service'
import { PageService } from 'src/app/core/services/page.service'
import { SharedDataService } from '../../../../core/services/shared-data.service'

@Component({
    selector: 'app-modal-options-success',
    templateUrl: './modal-options-success.component.html',
    styleUrls: ['../modal-options.component.scss', './modal-options-success.component.scss'],
    standalone: false
})
export class ModalOptionsSuccessComponent implements OnInit, OnDestroy {

  @Output() closeModal: EventEmitter<any> = new EventEmitter()
  @Output() toggleLoader: EventEmitter<any> = new EventEmitter()
  @Input() breakpoints: any = {
    extraSmall: false,
    small: false,
    medium: false,
    large: true,
    extraLarge: true
  }


  constructor(
    private api: ApiService,
    public page: PageService,
    private cdr: ChangeDetectorRef,
    public sharedDataService: SharedDataService,
    @Inject(PLATFORM_ID) private platformId: object,
    ) { }



  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.toggleLoader.emit(false)
    this.cdr.detectChanges()
    if (isPlatformBrowser(this.platformId)) {
      const formDiv = document.getElementById('leftPart')
      if (formDiv) {
        formDiv.click()
      }
      this.cdr.detectChanges()
    }
  }

  ngOnDestroy(): void {

  }


}
